import { Guid } from "./Guid";

export class Fee {
  public constructor() {
    this.FeeName = "";
    this.Description = "";
    this.Qty = 0;
    this.UnitPrice = 0.00;
    this.RowPointer = Guid.newGuid();
    this.FeeLine = 1;
    this.QuoteRowPointer = "";
    this.CreatedBy = "";
    this.UpdatedBy = "";
  }

  public RowPointer: string;
  public FeeLine: number;
  public FeeName: string;
  public Description: string;
  public Qty: number;
  public UnitPrice: number;
  public QuoteRowPointer: string;
  public CreatedBy: string;
  public UpdatedBy: string;
}
